export default __webpack_public_path__ + "static/media/catEmpty.c908a29d.svg";